export const habaProduct = {
  habaProductCard: {
    newTag: 'NEW',
    sustainableTag: 'Sustainable',
    color: 'Colors',
    personalizationBtn: 'View product',
    chooseSize: 'Choose size',
    aiImageAlt: 'AI-generated image',
  },
  habaProductDetails: {
    descriptionSectionTitle: 'Product details',
    descriptionSectionSubTitle: 'Description',
    downloadSectionTitle: 'Downloads',
    hintsSectionTitle: 'Notes',
    personalization: 'Add personalization',
    technicalData: 'Product features',
    notificationSubscribeTitle: 'Email notification activated',
    notificationSubscribeBody: 'You will be informed as soon as the product is available again',
    addToCart: 'Add to cart',
    akkuTyp: 'Battery type:',
    amountType: 'Pieces',
    cable: 'Power adapter/cable',
    batteryType: 'Battery type',
    quantity: 'Quantity',
    descriptionMoreLink: 'Product details',
    descriptionHeadline: 'Product description',
    taxDelivery: 'incl. VAT /',
    taxDeliveryLink: 'Shipping costs',
    freeDelivery: 'free shipping',
    outOfStock: 'No longer available',
    shareProduct: 'Share product',
    linkCopy: 'Copy link',
    linkCopied: 'Link copied',
    linkCopyFailed: 'Failed to copy link',
    note: '(please order separately)',
    notExchangeable: 'not replaceable',
    isNoMoreFixedBookPrice: 'Previous fixed book price lifted',
    selectVoucherValue: 'Select voucher value',
    personalize: {
      openButton: 'Personalize product',
      justForYou: 'Just for you',
      title: 'Personalize product',
      remove: 'Remove',
      save: 'ADD TO CART',
      cannotReturn:
        'Please understand that personalized items are excluded from exchange and return rights.',
      inputPlaceholder: 'Please enter desired text line {{index}}',
      informationSpace: 'Space for your details:',
      linesAndLength: '{{lines}} line(s) of {{length}} characters each',
      priceLine:
        'We will personalize this item for an additional <b>{{price}} per piece</b> according to your wishes.',
      script: 'Script font',
      block: 'Print font',
      wrongCharacters: 'Special characters are not allowed.',
    },
    pleaseSelectAmount: 'Please select an amount:',
    selectIndividualAmount: 'Or select a custom amount:',
    amountInfo: 'Only amounts without decimal places are allowed.',
    enterAmount: 'Enter amount',
    amountConfirm: 'Confirm',
    selectedVoucherValue: 'Selected voucher value',
    voucherValueAdjustedTitleSuccess: 'The amount has been adjusted',
    voucherValueAdjustedMessageSuccess: 'Now just add to cart',
    voucherValueAdjustedTitleError: 'Invalid input',
    voucherValueAdjustedMessageError:
      'The gift voucher value must have a valid format without decimal places',
    voucherIntervalValueAdjustedMessageError:
      'The selected gift voucher value must be between €10 and €500',
    articleNumber: 'Article number:',
    manufacturer: 'Manufacturer',
    specifications: {
      recommendedAge: 'Recommended age',
      numberOfPlayers: 'Number of players',
      playingTime: 'Playing time',
      playingTimeRange: 'approx. {{min}} – {{max}} minutes',
      playingTimeSingle: 'approx. {{value}} minutes',
      productDimensions: 'Product dimensions',
      weight: 'Weight',
      author: 'Author',
      authors: 'Authors',
      illustration: 'Illustration',
      dimensionAbbr: {
        height: 'H',
        width: 'W',
        depth: 'D',
        length: 'L',
      },
    },
    downloadInstructions: 'Download instructions',
    classificationYes: 'Yes',
    classificationNo: 'No',
    content: 'Contents',
    instructions: 'Material & care instructions',
    returnInformation: 'Free <u>returns</u> within <b>4 weeks</b>',
    certificate: {
      certifiedBy: 'Certified by',
      licenceNumber: 'License number',
    },
    ratingProduct: {
      modalButton: 'Rate product',
      rateProduct: 'Rate this product',
      yourRating: 'Your product rating*',
      ratingDescription: 'Product rating description*',
      descriptionError: 'This field is required and must be between 1 and 400 characters',
      additionalInformation:
        'By submitting, you agree to the <a href="{{guidelinesUrl}}" class="font-xs font-md-s" target="_blank" rel="noopener noreferrer">HABA guidelines</a> for reviews.',
      submitReview: 'Submit review',
      successfulTitle: 'Thank you for your review!',
      successfulText:
        'Your review is now being processed. We will notify you by email as soon as your review is visible on the product page.',
      backToProductButton: 'Back to product',
    },
    sort: {
      sortBy: 'Sorted by',
      date: 'Date',
      highestRating: 'Highest rating',
      lowestRating: 'Lowest rating',
    },
    sizeTable: {
      baby: 'Babies',
      girl: 'Girls',
      unisex: 'Boys',
      hat: 'Hats',
      shoe: 'Shoes',
      glove: 'Gloves',
    },
    minimumPrice: {
      bestPrice: '30-day best price:',
      learnMore: 'Learn more',
      currentPriceIsTheLowestPrice:
        'The "30-day best price" is the lowest price at which the retailer offered this product in the 30 days before the last price change.',
      currentPriceIsNotTheLowestPrice:
        'The "30-day best price" is the lowest price at which the retailer offered this product in the 30 days before the last price change. Due to past discount campaigns, the "30-day best price" may be lower than the current price.',
      understood: 'I understand',
      modalTitle: 'Why am I shown "Lowest price of the last 30 days"?',
      modalParagraph1:
        'Due to new EU legislation, we have added "Lowest price in the last 30 days". This helps both us and our customers to inform more transparently about product price changes in a timely manner.<br><br>For example, the lowest price of the product in the last 30 days before the start of the new sales campaign (e.g. "Winter clearance sale") was €100.00. This price is listed as "Lowest price of the last 30 days" when we announce the first price reduction (e.g. €90.00) in the newly launched campaign. The "Lowest price of the last 30 days" remains the same throughout the entire campaign, even if there are further price reductions within the same campaign (e.g. €80.00, €70.00, etc.).',
      modalTitle2: 'Why am I shown "Lowest price of the last 30 days"?',
      modalParagraph2:
        'According to the new EU price indication regulation, the so-called "previous price" applied by us is indicated for every communicated promotional campaign. What the legislator calls "previous price", we call "Lowest price of the last 30 days".',
      euLegislationLinkTitle:
        'More information about the new EU legislation on price indication can be found on this website.',
      euLegislationLink:
        'https://commission.europa.eu/law/law-topic/consumer-protection-law/unfair-commercial-practices-and-price-indication/price-indication-directive_en',
    },
    msrp: 'MSRP',
    availability: {
      green: 'In stock',
      yellow: 'Restock on the way',
      red: 'Available again soon',
    },
    shippingConditionsText:
      'For postage and packaging we charge a flat rate of <b>4.95 €</b>.<br><br>From 49 € your order is <b>FREE SHIPPING!</b>',
  },
  habaProductVariants: {
    color: 'Color',
    size: 'Size',
    chooseSize: 'Choose size',
    soldOut: 'Sold out',
    notifyMe: 'Notify me',
    toSizeTable: 'To size chart',
    selectSize: 'Select size',
  },
  habaProductPersonalization: {
    personalisation: 'Personalization',
    spaceForInformation: 'Space for your details',
    font: 'Font',
    entries: 'Your details',
    headline: 'Personalize product',
    remove: 'Remove',
    edit: 'Edit',
    successfullyAddedTitleNotification: 'Product personalized successfully',
    successfullyAddedMessageNotification:
      'The price has been updated to include personalization costs.',
    successfullyRemovedTitleNotification: 'Product personalization',
    successfullyRemovedMessageNotification: 'Has been removed successfully.',
    subheadline:
      'We will personalize this item exactly as you wish for an additional <strong>{{price}} per piece</strong>.',
    blockWriting: 'Block',
    handWriting: 'Cursive',
    errorTextLimitation: 'Space for your details: 1 line with 20 characters',
    textInputLabel: 'Please enter personalized text *',
    exclusionLabel:
      'Please note that personalized items have a delivery time of 1–2 days longer and cannot be returned.',
    close: 'Cancel',
    submit: 'Save',
    textInvalidMinLengthMessage: 'The text must be longer than one letter.',
    textInvalidMaxLengthMessage: 'The maximum number of characters has been reached.',
    textInvalidCharSetMessage:
      'Error personalization Input is limited to latin letters and numbers.',
  },
};
